import { HashRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import ScrollToTop from "react-router-scroll-top";

import "react-toastify/dist/ReactToastify.css";
import * as ROUTES from "./constans/rutas";
import AlertaState from "./context/alertas/alertaState";
import AuthState from "./context/autenticacion/authState";
import tokenAuth from "./config/tokenAuth";
import Desenganche from "./paginas/Desenganche/home";
import Mensualidades from "./paginas/Mensualidades";
import Convenios from "./paginas/Codigos";
import Juridicas from "./paginas/Juridicas";
import BManual from "./paginas/BManual";
import SupportDoc from "./paginas/SupportDoc";

import HomePage from "./paginas";
import RutaPrivada from "./components/rutas/RutaPrivada";
import LoginPage from "./paginas/auth/login";
import RegistroPage from "./paginas/auth/registro";
import EthicsChannel from "./paginas/EthicsChannel";
import ConsultInvoice from "./paginas/pdf";
import CreditNotes from "./paginas/CreditNotes";
import Facturacion from "./paginas/Facturacion";
import Planillas from "./paginas/Planillas";
import Auditoria from "./paginas/Auditoria";
import Clientes from "./paginas/Clientes";
import ModificaRecaudoList from "./paginas/Planillas/cierreTurno/ModificaRecaudoList";
import EditarCierreTurno from "./paginas/Planillas/cierreTurno/EditarCierreTurno";
import CierreDiaContainer from "./paginas/Planillas/CierreDia/CierreDiaContainer";
import EditarCierreDia from "./paginas/Planillas/CierreDia/EditarCierreDia";
import TransaccionalContainer from "./paginas/Planillas/Transaccional/TransaccionalContainer";
import EditarTransaccional from "./paginas/Planillas/Transaccional/EditarTransaccional";
import AjusteFechaContainer from "./paginas/Planillas/AjusteFecha/AjusteFechaContainer";
import TrasmitirGlobalContainer from "./paginas/Planillas/TrasmitirGlobal/TrasmitirGlobalContainer";
import AjusteMensualesContainer from "./paginas/Planillas/AjusteMensuales/AjusteMensualesContainer";
import TraspasoEfectivoDatafonoContainer from "./paginas/Planillas/TraspasoEfectivoDatafono/TraspasoEfectivoDatafonoContainer";

const token = localStorage.getItem("token");
if (token) {
  tokenAuth(token);
}

function App() {
  return (
    <>
      <AlertaState>
        <Router>
          <ScrollToTop>
            <AuthState>
              <div className="top-header" />
              <Switch>
                <Route exact path={ROUTES.LOGIN} component={LoginPage} />
                <RutaPrivada
                  exact
                  path={ROUTES.REGISTRO}
                  component={RegistroPage}
                />
                <RutaPrivada exact path={ROUTES.HOME} component={HomePage} />
                <RutaPrivada
                  exact
                  path={ROUTES.DESENGANCHE}
                  component={Desenganche}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.MENSUALIDADES}
                  component={Mensualidades}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.CONVENIOS}
                  component={Convenios}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.JURIDICAS}
                  component={Juridicas}
                />
                <RutaPrivada exact path={ROUTES.BMANUAL} component={BManual} />
                <RutaPrivada
                  exact
                  path={ROUTES.SUPPORTDOC}
                  component={SupportDoc}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.ETHICSCHANNEL}
                  component={EthicsChannel}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PDF}
                  component={ConsultInvoice}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.CREDITNOTES}
                  component={CreditNotes}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.FACTURACION}
                  component={Facturacion}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS}
                  component={Planillas}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.AUDITORIA}
                  component={Auditoria}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.CLIENTES}
                  component={Clientes}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_MODIFICA_RECAUDO}
                  component={ModificaRecaudoList}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_CIERRE_DIA}
                  component={CierreDiaContainer}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_EDITAR_DIA}
                  component={EditarCierreDia}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_EDITAR_DIA_ALT}
                  component={EditarCierreDia}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_TRANSACCIONAL}
                  component={TransaccionalContainer}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_EDITAR_TRANSACCIONAL}
                  component={EditarTransaccional}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_AJUSTE_FECHA}
                  component={AjusteFechaContainer}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_TRASMITIR_GLOBAL}
                  component={TrasmitirGlobalContainer}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_AJUSTE_MENSUALES}
                  component={AjusteMensualesContainer}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_EFECTIVO_DATAFONO}
                  component={TraspasoEfectivoDatafonoContainer}
                />
                <RutaPrivada
                  exact
                  path={ROUTES.PLANILLAS_EDITAR_TURNO}
                  component={EditarCierreTurno}
                />
              </Switch>
            </AuthState>
          </ScrollToTop>
        </Router>
        <ToastContainer />
      </AlertaState>
    </>
  );
}

export default App;
